import useTest10445 from 'hooks/test/use-test-10445';
import { ComponentProps, FC, ReactNode } from 'react';
import InCartBadge from './in-cart-badge';

interface Props extends ComponentProps<typeof InCartBadge> {
  wrap?: (badge: ReactNode) => ReactNode;
}

const InCartExperimentBadge: FC<Props> = ({ wrap = (badge) => badge, ...props }) => {
  const { isVariantA } = useTest10445();

  return wrap(isVariantA ? <InCartBadge {...props} /> : null);
};

export default InCartExperimentBadge;
